// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wt-post-info ul{list-style:disc;padding-left:25px}", "",{"version":3,"sources":["webpack://./components/theme-modern-immobilier/components/DescriptionDefault.vue"],"names":[],"mappings":"AACA,iBAGI,eAAY,CADZ,iBACgB","sourcesContent":["\n.wt-post-info ul {   \n    \n    padding-left: 25px;\n    list-style: disc;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
